require('packs/commons/validation')
import { msEmailDomains} from "packs/commons/validation"

$(function () {
  // 金額入力切り替え処理
  $(document).on('change', '#donation_donation_details_attributes_0_amount_other_for_select', function () {
    $('#donation_donation_details_attributes_0_amount').val($(this).val());
  });
  $(document).on('change', 'input[name="donation[donation_details_attributes][0][amount_for_select]"]', function () {
    var value = $('input[name="donation[donation_details_attributes][0][amount_for_select]"]:checked').val();
    if (value !== 'other') {
      $('#donation_donation_details_attributes_0_amount_other_for_select').prop('disabled', true).val('');
      $('#donation_donation_details_attributes_0_amount').val(value);
      // その他金額以外の場合未入力を許可するのでエラー状態を解除
      $('#donation_donation_details_attributes_0_amount_other_for_select').removeClass('c-form-error');
      $('#donation_donation_details_attributes_0_amount_other_for_select-error').hide();
    } else {
      $('#donation_donation_details_attributes_0_amount_other_for_select').prop('disabled', false);
      $('#donation_donation_details_attributes_0_amount').val('');
      $('#donation_donation_details_attributes_0_amount_other_for_select').change();
    }
  });
  $('input[name="donation[donation_details_attributes][0][amount_for_select]"]:checked').change();

  // 名前のカナ入力補完
  if ($('#donation_last_name').length > 0 && $('#donation_last_name_kana').length > 0) {
    AutoKana.bind('#donation_last_name', '#donation_last_name_kana', { katakana: true });
  }
  if ($('#donation_first_name').length > 0 && $('#donation_first_name_kana').length > 0) {
    AutoKana.bind('#donation_first_name', '#donation_first_name_kana', {katakana: true});
  }
  if ($('#donation_charge_last_name').length > 0 && $('#donation_charge_last_name_kana').length > 0) {
    AutoKana.bind('#donation_charge_last_name', '#donation_charge_last_name_kana', { katakana: true });
  }
  if ($('#donation_charge_first_name').length > 0 && $('#donation_charge_first_name_kana').length > 0) {
    AutoKana.bind('#donation_charge_first_name', '#donation_charge_first_name_kana', {katakana: true});
  }

  // 送付物の選択による住所の必須/任意切り替え
  let isAddressRequired = true;
  $(document).on('change', '#js-posting-input-group input[type=radio]', function () {
    const addressInputs = $('.js-address-input');
    if ($('#donation_receipt_kind_post').prop('checked')
      || $('#donation_active_report_kind_post').prop('checked')
      || $('#donation_direct_mail_kind_post').prop('checked')) {
      isAddressRequired = true;
      addressInputs.removeClass('c-form-label--optional');
      addressInputs.addClass('c-form-label--required');
    } else {
      isAddressRequired = false;
      addressInputs.removeClass('c-form-label--required');
      addressInputs.addClass('c-form-label--optional');
    }
  });
  $('#js-posting-input-group input[type=radio]').change();
  // 住所が必須かを返す
  const checkAddressRequired = function () {
    return isAddressRequired;
  }

  // 住所入力補完
  $(document).on('input', '#donation_postal_code', function () {
    var postalCode = $(this).val().replaceAll('-', '');
    if (postalCode.length <= 6) {
      return;
    }

    new YubinBango.Core(postalCode, function (address) {
      $('#donation_address1').val(address.region);
      $('#donation_address2').val(address.locality + address.street);
    });
  });

  // 確認ボタン
  $(document).on('click', '#js-confirm-button', function () {
    if ($('#js-donation-form').valid()) {
      $(window).scrollTop(0);
      setConfirmValues();
      $('#js-input-area').hide();
      $('#js-alert-area').hide();
      $('#js-confirm-area').show();
      $('#js-donation-input-step').removeClass('-current');
      $('#js-donation-confirm-step').addClass('-current');
    } else {
      // エラーを画面中央に持ってくる
      $(window).scrollTop($('label.c-form-error:visible:first').offset().top - ($(window).height() / 2));
    }
  });

  // 戻るボタン
  $(document).on('click', '#js-back-button', function () {
    $(window).scrollTop(0);
    $('#js-confirm-area').hide();
    $('#js-input-area').show();
    $('#js-donation-input-step').addClass('-current');
    $('#js-donation-confirm-step').removeClass('-current');
  });

  // 確認画面の内容を生成
  function setConfirmValues() {
    let amount = $('input[name="donation[donation_details_attributes][0][amount_for_select]"]:selected').val();
    if (!amount) {
      amount = $('#donation_donation_details_attributes_0_amount').val();
    }
    amount = parseInt(amount);
    $('#js-amount_text').text(`${amount.toLocaleString()}円`);
    $('#cardno_confirm').text($('#cardno').val());
    const expire = `${$('#expire_month_2i').val()}月 / ${$('#expire_year_1i').val()}年`;
    $('#expire_confirm').text(expire);
    $('#holdername_confirm').text($('#holdername').val());
    $('#js-name_text').text($('#donation_last_name').val() + "　" + $('#donation_first_name').val());
    $('#js-name_kana_text').text($('#donation_last_name_kana').val() + "　" + $('#donation_first_name_kana').val());
    const birthYear = $('#donation_birthed_on\\(1i\\)').val();
    const birthMonth = $('#donation_birthed_on\\(2i\\)').val();
    const birthDay = $('#donation_birthed_on\\(3i\\)').val();
    let birthedOn = '';
    if (birthYear && birthMonth && birthDay) {
      birthedOn = `${birthYear}年${birthMonth}月${birthDay}日`;
    }
    $('#js-birthed_on_text').text(birthedOn);
    $('#js-email_text').text($('#donation_email').val());
    $('#js-mail_news_kind_text').text($('label[for=' + $('input[name="donation[mail_news_kind]"]:checked').prop('id') + ']').text());
    $('#js-tel_text').text($('#donation_tel').val());
    $('#js-receipt_kind_text').text($('label[for=' + $('input[name="donation[receipt_kind]"]:checked').prop('id') + ']').text());
    $('#js-active_report_kind_text').text($('label[for=' + $('input[name="donation[active_report_kind]"]:checked').prop('id') + ']').text());
    $('#js-direct_mail_kind_text').text($('label[for=' + $('input[name="donation[direct_mail_kind]"]:checked').prop('id') + ']').text());
    const postalCode = $('#donation_postal_code').val();
    const address = `${$('#donation_address1').val()}${$('#donation_address2').val()}${$('#donation_address3').val()} ${$('#donation_address4').val()}`;
    let fullAddress = '';
    if (postalCode && address) {
      fullAddress = `〒${postalCode}\n${address}`;
    }
    $('#js-address_text').text(fullAddress);
    $('#js-privacy_policy_text').text($('#donation_agreement').prop('checked') ? '同意する' : '同意しない');
  }

  // バリデーション
  $('#js-donation-form').validate({
    errorClass: 'c-form-error',
    groups: {
      birthedOnGroup: 'donation[birthed_on(1i)] donation[birthed_on(2i)] donation[birthed_on(3i)]'
    },
    rules: {
      'donation[donation_details_attributes][0][amount_other_for_select]': {
        required: '#donation_donation_details_attributes_0_amount_for_select_other:checked',
        min: 500
      },
      cardno: {
        required: true,
        digits: true,
        rangelength: [14, 16]
      },
      'expire[month(2i)]': {
        required: true,
        digits: true
      },
      'expire[year(1i)]': {
        required: true,
        digits: true
      },
      securitycode: {
        required: true,
        digits: true,
        rangelength: [3, 4]
      },
      holdername: {
        required: true,
        alphabet: true,
        maxlength: 50
      },
      'donation[last_name]': {
        required: true
      },
      'donation[first_name]': {
        required: true
      },
      'donation[last_name_kana]': {
        required: true,
        katakana: true
      },
      'donation[first_name_kana]': {
        required: true,
        katakana: true
      },
      'donation[birthed_on(1i)]': {
        allOrNothing: '.js-birthed-on'
      },
      'donation[birthed_on(2i)]': {
        allOrNothing: '.js-birthed-on'
      },
      'donation[birthed_on(3i)]': {
        allOrNothing: '.js-birthed-on'
      },
      'donation[email]': {
        required: true,
        email: true,
        withoutMicrosoftDomains: true
      },
      'donation[email_confirmation]': {
        required: true,
        email: true,
        withoutMicrosoftDomains: true,
        equalTo: '#donation_email'
      },
      'donation[tel]': {
        jpPhoneNumber: true
      },
      'donation[postal_code]': {
        required: checkAddressRequired,
        postalCode: true
      },
      'donation[address1]': {
        required: checkAddressRequired
      },
      'donation[address2]': {
        required: checkAddressRequired
      },
      'donation[address3]': {
        required: checkAddressRequired
      },
      'donation[agreement]': {
        required: true
      }
    },
    messages: {
      'donation[donation_details_attributes][0][amount_other_for_select]': {
        required: 'その他金額を選択している場合、金額を入力してください',
        min: 'その他金額は500円以上で入力してください',
        number: 'その他金額は数字を入力してください'
      },
      cardno: {
        required: 'カード番号を入力してください',
        digits: 'カード番号は半角数字のみで入力してください',
        rangelength: 'カード番号の桁数が正しくありません',
        maxlength: 'カード番号の桁数が正しくありません'
      },
      'expire[month(2i)]': {
        required: '有効期限（月）を入力してください',
        digits: '有効期限（月）は数字のみで入力してください'
      },
      'expire[year(1i)]': {
        required: '有効期限（年）を入力してください',
        digits: '有効期限（年）は数字のみで入力してください'
      },
      securitycode: {
        required: 'セキュリティコードを入力してください',
        digits: 'セキュリティコードは数字のみで入力してください',
        rangelength: 'セキュリティコードは3桁または4桁で入力してください'
      },
      holdername: {
        required: 'カード名義を入力してください',
        alphabet: 'カード名義は半角英字のみで入力してください',
        maxlength: 'カード名義は50文字以内で入力してください'
      },
      'donation[last_name]': {
        required: '姓を入力してください'
      },
      'donation[first_name]': {
        required: '名を入力してください'
      },
      'donation[last_name_kana]': {
        required: '姓カナを入力してください',
        katakana: '姓カナはカタカナで入力してください'
      },
      'donation[first_name_kana]': {
        required: '名カナを入力してください',
        katakana: '名カナはカタカナで入力してください'
      },
      'donation[birthed_on(1i)]': {
        allOrNothing: '生年月日は年月日すべて入力してください'
      },
      'donation[birthed_on(2i)]': {
        allOrNothing: '生年月日は年月日すべて入力してください'
      },
      'donation[birthed_on(3i)]': {
        allOrNothing: '生年月日は年月日すべて入力してください'
      },
      'donation[email]': {
        required: 'メールアドレスを入力してください',
        email: 'メールアドレス形式で入力してください',
        withoutMicrosoftDomains: `メールアドレスには${msEmailDomains.join('、')}のメールアドレスは使用できません。`
      },
      'donation[email_confirmation]': {
        required: 'メールアドレス(確認)を入力してください',
        email: 'メールアドレス形式で入力してください',
        withoutMicrosoftDomains: `メールアドレス(確認)には${msEmailDomains.join('、')}のメールアドレスは使用できません。`,
        equalTo: 'メールアドレスが一致しません'
      },
      'donation[tel]': {
        jpPhoneNumber: '電話番号を入力してください'
      },
      'donation[postal_code]': {
        required: '郵便番号を入力してください',
        postalCode: '郵便番号形式で入力してください'
      },
      'donation[address1]': {
        required: '都道府県を入力してください'
      },
      'donation[address2]': {
        required: '住所(市区町村)を入力してください'
      },
      'donation[address3]': {
        required: '住所2(番地以下)を入力してください'
      },
      'donation[agreement]': {
        required: 'プライバシーポリシーに同意してください'
      }
    }
  });

  // 送付物のダイアログ表示
  $(document).on('click', '#js-about-postings-modal-button', function () {
    $('#js-about-postings-modal').addClass('-opened');
  });
  $(document).on('click', '#js-about-postings-modal-backdrop,.js-close-modal-cancel-button', function () {
    $('#js-about-postings-modal').removeClass('-opened');
  });

  // 寄付送信前のカードトークン取得とreCAPTCHA
  $(document).on('click', '#js-confirm-submit-button', async function () {
    $('#js-confirm-submit-button').prop('disabled', true);
    // reCAPTCHAのトークン更新
    const tokenInput = $('#g-recaptcha-response-data-fundraise-donation');
    if (tokenInput && typeof window.executeRecaptchaForFundraiseDonationAsync === 'function') {
      const token = await window.executeRecaptchaForFundraiseDonationAsync();
      tokenInput.val(token);
    }

    $(this).prop('disabled', true);

    Multipayment.init(process.env.GMO_CARD_SHOP_ID);
    Multipayment.getToken(
      {
        cardno: $('#cardno').val(),
        expire: $('#expire_year_1i').val() + ('00' + $('#expire_month_2i').val()).slice(-2),
        securitycode: $('#securitycode').val(),
        holdername: $('#holdername').val()
      },
      function (result) {
        if (result.resultCode === '000') {
          $('#donation_token').val(result.tokenObject.token);
          // クレカ情報は送信しない
          $('#cardno').prop('disabled', true).val('');
          $('#expire_year_1i').prop('disabled', true).val('');
          $('#expire_month_2i').prop('disabled', true).val('');
          $('#securitycode').prop('disabled', true).val('');
          $('#holdername').prop('disabled', true).val('');
          $('#js-donation-form').submit();
        } else {
          // エラー表示は適当
          alert('クレジットカード情報が正しくないです。err_no: ' + result.resultCode);
          $('#js-confirm-submit-button').prop('disabled', false);
        }
      }
    );
  });
});
